import type { Element as SlateElement, Editor } from 'slate';
import { Transforms } from 'slate';
import type { MentionEditor } from './types';
import { MentionElementType, type MentionElement, type MentionUser } from './types';

export function isMentionElement(element: SlateElement) {
  return element.type === MentionElementType;
}

export function insertMention(editor: Editor, user: MentionUser) {
  if (!user) {
    throw new Error('User is required.');
  }

  const mention: MentionElement = {
    type: MentionElementType,
    user,
    children: [{ text: '' }],
  };
  Transforms.insertNodes(editor, mention);
  Transforms.move(editor);
}

export function withMentionEditor(editor: Editor): MentionEditor {
  const { isInline, isVoid, markableVoid } = editor;

  editor.isInline = (element: SlateElement) => {
    return isMentionElement(element) || isInline(element);
  };

  editor.isVoid = (element: SlateElement) => {
    return isMentionElement(element) || isVoid(element);
  };

  editor.markableVoid = (element: SlateElement) => {
    return isMentionElement(element) || markableVoid(element);
  };

  return Object.assign(editor, {
    insertMention(user: MentionUser) {
      return insertMention(editor, user);
    },
  });
}

export function getMentionName(user: MentionUser) {
  return user.user_id === '*'
    ? `@${user.name}`
    : `@${user.original_name}${user?.username && `(${user?.username})`}`;
}
